<template>
  <b-row class="pt-3 pb-3">
    <b-col class="mr-auto" cols="12" md="auto">
      <h3 id="title">{{title}}</h3>
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: ["title"]
};
</script>